import BookingRodoForm from '@/components/booking/RodoForm'
import '@/stylesheets/modules/BookingRodo.scss'

function createRootElement (root) {
  const placeholder = document.createElement('div')
  placeholder.classList.add('booking-rodo')
  root.insertAdjacentElement('afterend', placeholder)
  return placeholder
}

export function init () {
  const form = document.querySelector('.booking-rodo-form')
  if (form) {
    const root = createRootElement(form)
    new BookingRodoForm({ el: root, propsData: { form } })
  }
}


// WEBPACK FOOTER //
// ./src/modules/bookingRodoForm.js